/* eslint-disable @typescript-eslint/no-empty-object-type */
import React, {
  type ForwardRefRenderFunction,
  type PropsWithoutRef,
  type RefAttributes,
} from 'react';

type OmitClassName<T> = Omit<T, 'className'>;

export function forwardRefNoClassName<T, P = {}>(
  render: ForwardRefRenderFunction<T, OmitClassName<P>>,
): React.ForwardRefExoticComponent<PropsWithoutRef<OmitClassName<P>> & RefAttributes<T>> {
  return React.forwardRef<T, OmitClassName<P>>(render);
}
